<template>
  <div class="attendance-apply-audit-page">
    <PageHeaderLayout :isBack="true">
      <div v-loading="loadingStatus" class="main-page-content apply-audit">
        <div class="apply-audit__header">
          <div class="apply-audit__header-main">
            <div class="apply-audit__title">{{ pageTitle }}</div>
            <div class="apply-audit__meta">
              <span>申请人：{{ detail.user_name || "-" }}</span>
              <span>任务：{{ detail.mission_name || "-" }}</span>
            </div>
            <div class="apply-audit__status-row">
              <span class="apply-audit__status-label">状态：</span>
              <el-tag size="mini" :type="statusTagType">{{ detail.apply_status_text || "-" }}</el-tag>
            </div>
          </div>
          <div class="apply-audit__submit-time">
            提交时间：{{ detail.submit_time || "-" }}
          </div>
        </div>

        <div class="apply-audit__card">
          <div class="apply-audit__card-title">申请信息</div>
          <div class="apply-audit__grid">
            <div class="apply-audit__grid-item">
              <div class="apply-audit__label">申请人</div>
              <div class="apply-audit__value">{{ detail.user_name || "-" }}</div>
            </div>
            <div class="apply-audit__grid-item">
              <div class="apply-audit__label">申请类型</div>
              <div class="apply-audit__value">{{ detail.apply_type_text || "-" }}</div>
            </div>
            <div class="apply-audit__grid-item">
              <div class="apply-audit__label">所属任务</div>
              <div class="apply-audit__value">{{ detail.mission_name || "-" }}</div>
            </div>
            <div class="apply-audit__grid-item">
              <div class="apply-audit__label">班次</div>
              <div class="apply-audit__value">{{ shiftText }}</div>
            </div>
            <div class="apply-audit__grid-item">
              <div class="apply-audit__label">{{ detail.apply_type === 2 ? "实际打卡时段" : "补卡时间" }}</div>
              <div class="apply-audit__value">{{ actualTimeText }}</div>
            </div>
          </div>

          <div class="apply-audit__row">
            <div class="apply-audit__label">申请标题</div>
            <div class="apply-audit__row-value">{{ applyTitle }}</div>
          </div>

          <div class="apply-audit__row">
            <div class="apply-audit__label">申请说明</div>
            <div class="apply-audit__row-value">{{ detail.apply_reason || "-" }}</div>
          </div>

          <div v-if="detail.apply_remark" class="apply-audit__row">
            <div class="apply-audit__label">审批备注</div>
            <div class="apply-audit__row-value">{{ detail.apply_remark }}</div>
          </div>
        </div>

        <div class="apply-audit__actions">
          <el-button v-if="canAudit" @click="openRejectDialog">驳回</el-button>
          <el-button
            v-if="canAudit"
            type="primary"
            :loading="approveLoading"
            @click="handleApprove"
          >
            通过
          </el-button>
        </div>
      </div>
    </PageHeaderLayout>

    <el-dialog
      title="驳回申请"
      :visible.sync="rejectDialog.visible"
      width="720px"
      append-to-body
      destroy-on-close
    >
      <div class="reject-dialog">
        <div class="reject-dialog__desc">请填写驳回原因，申请人将收到通知</div>
        <div class="reject-dialog__label">驳回原因</div>
        <el-input
          v-model.trim="rejectDialog.remark"
          type="textarea"
          :rows="6"
          maxlength="200"
          show-word-limit
          placeholder="请输入驳回原因"
        />
      </div>
      <span slot="footer">
        <el-button @click="rejectDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="rejectLoading" @click="submitReject">确认驳回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";

const RECORD_LIST_REFRESH_FLAG_KEY = "attendance_clock_record_refresh_record_list";
const ABNORMAL_LIST_REFRESH_FLAG_KEY = "attendance_clock_record_refresh_abnormal_list";
const STATS_LIST_REFRESH_FLAG_KEY = "attendance_clock_record_refresh_stats_list";

function extractTime(value) {
  if (!value) return "";
  const str = String(value).trim();
  if (!str) return "";
  if (/^\d{2}:\d{2}$/.test(str)) return str;
  const match = str.match(/(\d{2}:\d{2})/);
  return match ? match[1] : str;
}

export default {
  name: "AttendanceApplyAudit",
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      loadingStatus: false,
      approveLoading: false,
      rejectLoading: false,
      detail: {},
      rejectDialog: {
        visible: false,
        remark: "",
      },
    };
  },
  computed: {
    applyId() {
      const q = this.$route.query || {};
      return q.id != null ? String(q.id) : "";
    },
    canAudit() {
      return Number(this.detail.apply_status) === 0;
    },
    pageTitle() {
      return Number(this.detail.apply_type) === 2 ? "请假申请" : "补卡申请";
    },
    statusTagType() {
      const status = Number(this.detail.apply_status);
      if (status === 1) return "success";
      if (status === 2) return "danger";
      if (status === 3) return "info";
      return "warning";
    },
    shiftText() {
      return this.detail.shift_text || "-";
    },
    actualTimeText() {
      if (Number(this.detail.apply_type) === 2) {
        const start = extractTime(this.detail.leave_start_time);
        const end = extractTime(this.detail.leave_end_time);
        if (start && end) return `${start}-${end}`;
      }
      const clockIn = this.detail.clock_in_time;
      const clockOut = this.detail.clock_out_time;
      if (clockIn && clockOut) return `${clockIn}-${clockOut}`;
      if (clockIn) return clockIn;
      if (clockOut) return clockOut;
      return this.detail.work_time_text || "-";
    },
    applyTitle() {
      return this.detail.apply_title || "-";
    },
  },
  watch: {
    "$route.query.id"() {
      this.fetchDetail();
    },
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    markNeedRefresh() {
      window.sessionStorage.setItem(RECORD_LIST_REFRESH_FLAG_KEY, "1");
      window.sessionStorage.setItem(ABNORMAL_LIST_REFRESH_FLAG_KEY, "1");
      window.sessionStorage.setItem(STATS_LIST_REFRESH_FLAG_KEY, "1");
    },
    async fetchDetail() {
      if (!this.applyId) {
        this.$message.warning("缺少申请单 ID");
        return;
      }
      this.loadingStatus = true;
      try {
        const res = await this.$api.checkInApplyView(this.applyId);
        this.detail = res && typeof res === "object" ? res : {};
      } catch (e) {
        const msg =
          (e && e.data && e.data.message) || (e && e.msg) || e.message || "申请详情加载失败";
        this.$message.error(msg);
      } finally {
        this.loadingStatus = false;
      }
    },
    async handleApprove() {
      if (!this.applyId) return;
      this.approveLoading = true;
      try {
        await this.$api.checkInApplyAudit({
          id: this.applyId,
          apply_status: 1,
        });
        this.markNeedRefresh();
        this.$message.success("审批通过");
        this.fetchDetail();
      } catch (e) {
        const msg =
          (e && e.data && e.data.message) || (e && e.msg) || e.message || "审批失败";
        this.$message.error(msg);
      } finally {
        this.approveLoading = false;
      }
    },
    openRejectDialog() {
      this.rejectDialog.visible = true;
      this.rejectDialog.remark = "";
    },
    async submitReject() {
      if (!this.rejectDialog.remark) {
        this.$message.warning("请输入驳回原因");
        return;
      }
      this.rejectLoading = true;
      try {
        await this.$api.checkInApplyAudit({
          id: this.applyId,
          apply_status: 2,
          apply_remark: this.rejectDialog.remark,
        });
        this.markNeedRefresh();
        this.$message.success("已驳回申请");
        this.rejectDialog.visible = false;
        this.fetchDetail();
      } catch (e) {
        const msg =
          (e && e.data && e.data.message) || (e && e.msg) || e.message || "驳回失败";
        this.$message.error(msg);
      } finally {
        this.rejectLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.apply-audit {
  min-height: calc(100vh - 180px);
}

.apply-audit__header,
.apply-audit__card {
  background: #fff;
  border: 1px solid #ebeef5;
}

.apply-audit__header {
  padding: 22px 24px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.apply-audit__title {
  font-size: 32px;
  font-weight: 600;
  color: #303133;
  line-height: 1.2;
}

.apply-audit__meta {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 14px;
  color: #303133;
}

.apply-audit__status-row {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.apply-audit__status-label,
.apply-audit__submit-time {
  font-size: 14px;
  color: #303133;
}

.apply-audit__card {
  padding: 18px 24px 28px;
}

.apply-audit__card-title {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.apply-audit__grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 18px;
  padding-bottom: 18px;
  border-bottom: 1px solid #ebeef5;
}

.apply-audit__grid-item {
  min-width: 0;
}

.apply-audit__label {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.apply-audit__value,
.apply-audit__row-value {
  font-size: 14px;
  color: #303133;
  line-height: 1.7;
  word-break: break-word;
}

.apply-audit__row {
  padding: 14px 0;
  border-bottom: 1px solid #ebeef5;
}

.apply-audit__actions {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 22px;
}

.reject-dialog {
  padding: 10px 12px 0;
}

.reject-dialog__desc {
  margin-bottom: 42px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.reject-dialog__label {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

@media (max-width: 1400px) {
  .apply-audit__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .apply-audit__header {
    flex-direction: column;
    gap: 12px;
  }

  .apply-audit__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
